// hooks/useSingletonCrud.js
import { useState } from "react";
import { apiServiceSingleton } from "../services/apiServiceSingleton";

export const useSingletonCrud = (endpoint, fileFields = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});

  const hasFile = (item) =>
    fileFields.some((field) => item[field] instanceof File);

  const fetchSingleton = async () => {
    setLoading(true);
    try {
      const res = await apiServiceSingleton.get(endpoint);
      // Support nested data structure from your API response
      const extracted = res?.data?.data?.data || res?.data?.data || res.data;
      setData(extracted);
      setErrors({});
      return extracted;
    } catch (error) {
      console.error("FetchSingleton error:", error);
      setErrors({ fetch: error.message || "Failed to fetch data" });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const updateSingleton = async (item) => {
    setLoading(true);
    try {
      let res;
      if (hasFile(item)) {
        res = await apiServiceSingleton.updateWithFile(endpoint, item);
      } else {
        res = await apiServiceSingleton.update(endpoint, item);
      }

      const updated = res?.data?.data?.data || res?.data?.data || res.data;
      setData(updated);
      setErrors({});
      return updated;
    } catch (error) {
      console.error(
        "updateSingleton error:",
        error.response?.data || error.message
      );
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors || { general: "Validation failed" });
      } else {
        setErrors({ general: error.message || "Update failed" });
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    errors,
    fetchSingleton,
    updateSingleton,
  };
};